import { render, staticRenderFns } from "./DIS_subpagehero.vue?vue&type=template&id=0cb8bb0d&"
import script from "./DIS_subpagehero.vue?vue&type=script&lang=js&"
export * from "./DIS_subpagehero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports